import {
  MUTE_TRIBUN_USER_REQUEST,
  MUTE_TRIBUN_USER_SUCCESS,
  MUTE_TRIBUN_USER_FAILURE
} from 'Store/constants';

const initialState = {
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MUTE_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case MUTE_TRIBUN_USER_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case MUTE_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
